import React from 'react'

import './index.scss'

import { createHashHistory } from 'history'

export default function TopEnterTIps(props) {
  let { type, tab } = props

  // type种类
  // 'bind'绑定 默认
  // 'appeal'申诉
  const config = {
    'bind': {
      mainTitle: '如您已入驻腾讯音乐人，请直接绑定，无须再次入驻，',
      tips: '立即绑定>',
      to: '/'
    },
    'appeal': {
      mainTitle: '如有其他人冒领账号，您可以进行申述，',
      tips: '申诉提示>',
      to: '/'
    },
    'enter': {
      mainTitle: '以上都不是我的账号，',
      tips: '立即入驻>',
      to: '/enter'
    },
    'enter-choose-bind': {
      mainTitle: '如您已入驻腾讯音乐人，请绑定手机即可同步。',
      tips: '立即绑定',
      to: '/'
    }
  }

  let target = config[type || 'bind']

  function toBind() {
    if (tab) return tab()
    createHashHistory().push(target.to)
  }

  return (<div className={"TipEnterTips" + (type === 'enter' ? ' enter' : '')}>
    {target.mainTitle}
    <span className="bind" onClick={toBind}>{target.tips}</span>
  </div>)
}